/*--------------------------------------
 SWIPER
 --------------------------------------*/
SwiperHome = {
  init: function () {
    var swiper = new Swiper(".swiper-products-home", {
      navigation: {
        nextEl: ".swiper-products-home-button-next",
        prevEl: ".swiper-products-home-button-prev",
      },
    });

  }
};

$(document).ready(function () {
  console.log("hello!");
  SwiperHome.init();
});
